<template>
  <div class="elsa-table-layout">
    <div class="elsa-table-layout-title" v-if="showTitle">
      <h1 class="title-header">
        {{ title }}
      </h1>
    </div>
    <slot></slot>
    <div class="elsa-table-layout-footer">
      <pagination :page-size="pageSize" :total="total" :current-page.sync="_currentPage" v-on:current-change="currentChange" :pager-counter="pageCounter" />
      <over-table-pagination :currentPage="_currentPage" :pageSize="pageSize" :total="total" :formatter="overtablePaginationFormatter" />
    </div>
  </div>
</template>

<script>
import OverTablePagination from '@/components/common/v2/OverTablePagination'
import Pagination from '@/components/common/Pagination'
import { PAGE_COUNTER, NUMBER_ELEMENTS_PER_PAGE } from '@/constants/generic'
import { STUDENT } from '@/constants/userRoles'

export default {
  components: {
    OverTablePagination,
    Pagination
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number
    },
    pageCounter: {
      type: Number,
      default: PAGE_COUNTER
    },
    pageSize: {
      type: Number,
      default: NUMBER_ELEMENTS_PER_PAGE
    },
    currentChange: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    search: {},
    screen: {
      type: String,
      default: STUDENT
    }
  },
  data() {
    return {
      showPendingUsersModal: false,
      actionModal: '',
      actionOptions: [
        { label: this.$t('study_sets.assign_to_class'), value: 'assign' },
        { label: this.$t('study_sets.delete'), value: 'delete' }
      ]
    }
  },
  computed: {
    _currentPage: {
      get() {
        return this.currentPage
      },
      set(page) {
        this.$emit('update:current-page', page)
      }
    }
  },
  methods: {
    overtablePaginationFormatter(start, end, total) {
      return this.$t('information.show_from_to_of_total', {
        start: start,
        end: end,
        total: total
      })
    },
    changeActions(actions) {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/colors';

::v-deep .search-form {
  input.el-input__inner {
    background: none !important;
  }
}

.actions {
  margin-top: 0px;
  margin-bottom: 0px;
  display: flex;
  justify-content: flex-start;

  &::v-deep .el-collapse {
    border: none;

    .el-collapse-item__header {
      min-width: 185px;
      // width: 160px;
      height: 40px;
      background: $purple;
      border: 2px solid $purple;
      border-radius: 45px;
      font-weight: 600;
      font-size: 14px;
      color: white;
      text-align: center;
      .button {
        width: 100%;
        i {
          font-size: 18px;
          vertical-align: text-top;
          margin-right: 2px;
        }
      }
    }

    .el-collapse-item__wrap {
      position: absolute;
      z-index: 2;
      margin-top: 8px;
      box-shadow: 0px 4px 7px rgba(4, 33, 50, 0.1);
      padding: 12px 16px;
      min-width: 220px;
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
  }
}

.options {
  display: flex;
  flex-direction: row;
  align-items: center;
  display: flex;
  justify-items: flex-start;
  height: 40px;
}

.actions .options ::v-deep .el-collapse .el-collapse-item__header {
  background: linear-gradient(180deg, #29f4ff -46.11%, #5257ff 151.97%);
  box-shadow: 0px 8px 18px rgba(69, 137, 255, 0.26);
  border-radius: 50px;
  font-weight: bold;
  font-size: 14px;
  color: white;
  padding-right: 10px;

  &.is-active {
    color: white;
    background-color: $purple;
  }
}

::v-deep .action-item {
  display: flex;
  flex-direction: row;
  margin-top: auto;
  margin-bottom: auto;
  color: $purple;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  line-height: 22px;

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }

  &:hover {
    font-size: 14px;
    font-weight: 800;
  }

  i {
    border-width: 2px;
    height: 16px;
    width: 16px;
    padding-right: 8px;
    font-size: 16px;
    margin: auto 0;
  }
}

::v-deep .el-table tr {
  cursor: pointer;
}
.elsa-table-layout {
  padding: 40px;
}

.elsa-table-layout-footer {
  padding-top: 48px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 24px !important;
  position: relative;
  height: 32px;
    align-items: center;
  .el-pagination {
    position: absolute;
    /* width: 100%; */
    margin: auto;
    margin-left: auto;
    left: 50%;
    transform: translateX(-50%);
    margin-right: auto;
  }
}

::v-deep .elsa-input .el-input .el-input__inner {
  height: 50px;
}
button.invite-single-learner {
  background: #007eff;
  border-radius: 8px;
  border: none;
  height: 48px;
  color: white;
  padding: 16px;
  font-size: 18px;
  min-width: 215px;
  cursor: pointer;
  // font-weight: bold;
  margin: 0 10px;
  &:hover {
    background: #0362c4;
  }
}
.pending-learner {
  height: 48px;
}
.elsa-table-layout-title {
  .title-header {
    margin: 8px 0 32px 0px;
  }
}

::v-deep .over-table-pagination {
  width: auto !important;
}
</style>
